import React from 'react';

import * as S from './styles';

export default function WaitingForDataDynamicPage() {
	return (
		<S.container>
			<p>Aguardando dados</p>
		</S.container>
	);
}
